import { isServer } from '@sitecore-jss/sitecore-jss/utils';

import { ECOMMERCE_DATA_LAYER_ITEM, useDataLayerDefaultProps } from './defaultProps';
import { fillEmptyValues } from './utils';

export interface EcommerceItem {
  promotion_id?: string;
  promotion_name?: string;
  creative_name?: string;
  creative_slot?: number;
  [key: string]: unknown;
}

export interface EcommerceDataLayerPayload {
  component?: string;
  event?: string;
  ecommerce?: {
    items?: EcommerceItem[];
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export const useRegisterEcommerceDataLayerAction = () => {
  const defaultProps = useDataLayerDefaultProps(ECOMMERCE_DATA_LAYER_ITEM);

  return (data: EcommerceDataLayerPayload): Record<string, unknown>[] | undefined => {
    if (typeof globalThis !== 'undefined' && !isServer()) {
      globalThis.dataLayer = globalThis?.dataLayer || [];

      const normalizedData = fillEmptyValues({
        ...data,
        ...defaultProps?.defaultGlobalProps,
      });

      if (normalizedData?.ecommerce?.items?.length) {
        normalizedData.ecommerce.items = normalizedData.ecommerce.items.map((item) =>
          fillEmptyValues({ ...item, ...defaultProps?.defaultItemProps })
        );
      }

      globalThis.dataLayer.push(normalizedData);

      return globalThis.dataLayer;
    }
  };
};
